"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("core-js/modules/es6.object.assign");
const react_1 = __importDefault(require("react"));
const react_helmet_1 = require("react-helmet");
const styled_components_1 = __importStar(require("styled-components"));
const atoms_1 = require("@components/atoms");
const molecules_1 = require("@components/molecules");
const organisms_1 = require("@components/organisms");
const _theme_1 = __importDefault(require("@theme"));
const _utils_1 = require("@utils");
require("../../assets/stylesheets/reset.min.css");
require("../../assets/stylesheets/base.css");
var favicon = require('../../assets/images/icons/favicon.png'); // Component
var Layout = function Layout(_ref) {
    var subHeaderContent = _ref.subHeaderContent, subHeaderMobileOnly = _ref.subHeaderMobileOnly, subHeaderShiftAtScrollPoint = _ref.subHeaderShiftAtScrollPoint, dark = _ref.dark, children = _ref.children, className = _ref.className;
    var _React$useState = react_1.default.useState(false), loaded = _React$useState[0], setLoaded = _React$useState[1];
    react_1.default.useEffect(function () {
        setTimeout(function () {
            return setLoaded(true);
        }, 5);
    }, []);
    return /*#__PURE__*/ react_1.default.createElement(react_1.default.Fragment, null, /*#__PURE__*/ react_1.default.createElement(react_helmet_1.Helmet, {
        title: "PRIOR",
        meta: [{
                name: "description",
                content: "We design custom travel that unlocks the real, the rare and the wonderful, creating once-in-a-lifetime experiences around the globe."
            }, {
                name: "keywords",
                content: "travel"
            }],
        link: [{
                rel: "shortcut icon",
                type: "image/png",
                href: "" + favicon
            }]
    }), /*#__PURE__*/ react_1.default.createElement(organisms_1.SiteHeader, {
        subHeaderContent: subHeaderContent,
        subHeaderMobileOnly: subHeaderMobileOnly,
        subHeaderShiftAtScrollPoint: subHeaderShiftAtScrollPoint
    }), /*#__PURE__*/ react_1.default.createElement("div", {
        id: "top"
    }), /*#__PURE__*/ react_1.default.createElement(styled_components_1.ThemeProvider, {
        theme: _theme_1.default
    }, /*#__PURE__*/ react_1.default.createElement(Wrapper, Object.assign({
        noSubHeader: !subHeaderContent
    }, {
        dark: dark,
        loaded: loaded,
        subHeaderMobileOnly: subHeaderMobileOnly
    }, {
        className: className + " loadable"
    }), /*#__PURE__*/ react_1.default.createElement(atoms_1.Padding, null, children)), /*#__PURE__*/ react_1.default.createElement(organisms_1.SiteMap, null), /*#__PURE__*/ react_1.default.createElement(molecules_1.CopyrightLine, null), /*#__PURE__*/ react_1.default.createElement(organisms_1.NotificationWidget, null)));
}; // Styling
/* Note: This padding compensates for the height of the fixed header and
 *       "quicklinks" bar. See /src/components/organisms/SiteHeader.tsx
 */
var Wrapper = styled_components_1.default.main.attrs(function (_ref2) {
    var loaded = _ref2.loaded;
    return {
        style: {
            opacity: loaded ? 1 : 0
        }
    };
}).withConfig({
    displayName: "Layout__Wrapper",
    componentId: "sc-1ll8rez-0"
})(["transition:opacity 0.25s ease-in-out;", " & p,& h1,& h2,& h3,& h4,& h5,& h6{", "}padding-top:", "px;", "{padding-top:", "px;}", "{padding-top:", "px;}"], function (props) {
    return props.dark && "\n    background-color: " + _theme_1.default.palette.ink + ";\n    color: " + _theme_1.default.palette.snow + ";\n  ";
}, function (props) {
    return props.dark && "\n      color: " + _theme_1.default.palette.snow + ";\n    ";
}, function (props) {
    return props.noSubHeader ? _theme_1.default.headerHeight['mobile'] : 112;
}, _utils_1.mediaQuery('laptop'), function (props) {
    return props.noSubHeader || props.subHeaderMobileOnly ? _theme_1.default.headerHeight['tablet'] : 144;
}, _utils_1.mediaQuery('desktop'), function (props) {
    return props.noSubHeader || props.subHeaderMobileOnly ? _theme_1.default.headerHeight['desktop'] : 168;
}); // Types
exports.default = Layout;
